"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseShoppingPortalParams = exports.getDefaultShoppingPortalContext = void 0;
const server_1 = require("../../utils/server");
const getDefaultShoppingPortalContext = () => ({
    customerId: '',
    forwardedFor: '',
    forwardedHost: 'www.amazon.com',
    headers: (0, server_1.serverOnly)({}),
    isEnabled: false,
    languageCode: 'en-US',
    marketplaceId: 'ATVPDKIKX0DER',
    requestId: ''
});
exports.getDefaultShoppingPortalContext = getDefaultShoppingPortalContext;
const getBaseShoppingPortalParams = () => ({
    contentType: 'text/x-html-parts;charset=UTF-8',
    delimiter: '&&&Portal&Delimiter&&&',
    navTemplateType: 'standard'
});
exports.getBaseShoppingPortalParams = getBaseShoppingPortalParams;
__exportStar(require("./types"), exports);
